<template>
	<div class="modal-wpr">
		<div v-click-outside="closeVideo" class="modal">
			<div class="modal-header">
				<button aria-label="Close" class="closeBtn" data-dismiss="modal" type="button" @click="closeVideo">
					<img src="/images/icon-close-white.svg" alt="" />
				</button>
			</div>
			<video ref="video" :src="videoSrc" autoplay controls @keyup.esc="closeVideo"></video>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Lytics from "@/classes/Lytics";
import ClickOutside from 'vue-click-outside'
import featureMixin from "@/mixins/featureMixin";

export default {
	directives: {
		ClickOutside
	},
	mixins: [featureMixin],
	data() {
		return {
			featurePath: "videoModal",
			updateVideoProgress: null
		}
	},
	computed: {
		...mapState(['currentVideo', 'currentPageNumber']),
		...mapGetters('config', ['branding']),
		accessKey() {
			return this?.config?.accessKey || '';
		},
		videoSrc() {
			return `${this.currentVideo}`;
		}
	},


	methods: {
		...mapActions(['setCurrentVideo']),

		closeVideo() {
			this.setCurrentVideo(null);
		},

		videoLoadedLytics() {
			console.log('video length', this.$refs.video.duration)
			Lytics.TriggerVideoLength({
				length: this.$refs.video.duration
			})

			Lytics.TriggerVideoClick(
				this.videoSrc,
				this.$refs.video.duration,
                this.currentPageNumber,
                this.searchIsVisible
			)
		},

		videoProgressLytics(progress) {
			Lytics.TriggerVideoProgress({
				url: this.videoSrc,
				duration: this.$refs.video.duration,
				progress
			})
		}
	},

	mounted() {
		const video = this.$refs.video;
		let lastPercentageLogged = 0;

		this.updateVideoProgress = () => {
			const percentagePlayed = Math.floor((100 / video.duration) * video.currentTime);

			if (percentagePlayed >= 25 && lastPercentageLogged < 25) {
				this.videoProgressLytics(25);
				lastPercentageLogged = 25;
			} else if (percentagePlayed >= 50 && lastPercentageLogged < 50) {
				this.videoProgressLytics(50);
				lastPercentageLogged = 50;
			} else if (percentagePlayed >= 75 && lastPercentageLogged < 75) {
				this.videoProgressLytics(75);
				lastPercentageLogged = 75;
			} else if (percentagePlayed >= 100 && lastPercentageLogged < 100) {
				this.videoProgressLytics(100);
				Lytics.TriggerVideoCompletion({
					url: this.videoSrc,
					duration: this.$refs.video.duration,
				});
				lastPercentageLogged = 100;
			}
		}

		video.addEventListener('timeupdate', this.updateVideoProgress, false)

		this.$refs.video.focus();
		this.$refs.video.addEventListener('loadeddata', this.videoLoadedLytics, false)
	},

	beforeDestroy() {
		this.$refs.video.removeEventListener('loadeddata', this.videoLoadedLytics)
		this.$refs.video.removeEventListener('timeupdate', this.updateVideoProgress)
	}
}
</script>

<style lang="scss" scoped>
.modal-header {
	display: flex !important;
	flex-flow: row-reverse !important;
}

.closeBtn {
	width: 25px;
	height: 25px;
	position: absolute;
	z-index: 99;
	border-radius: 50px;
	background-color: red;
	border: none;
	margin: 10px;
}

.modal-wpr {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.75);
	z-index: 99;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-flow: column;

	.modal {
		max-width: 95%;
    max-height: 82%;
    margin-top: 1.5em;

		video {
			width: 100%;
			height: 100%;
      max-height: 80vh;
      max-width: 80vw;
      object-fit: contain;
		}
	}
}
</style>
